import { Component, OnInit } from '@angular/core';
import { ALLOW_MULTIPLE_PLATFORMS } from '@angular/core/src/application_ref';
import { LoaderService } from 'app/services/loader.service';
import { CategoryService } from '../category.service';

@Component({
  selector: "app-vendorpo-maintenance",
  templateUrl: "./vendorpo-maintenance.component.html",
  styleUrls: ["./vendorpo-maintenance.component.css"],
  providers: [CategoryService],
})
export class VendorpoMaintenanceComponent implements OnInit {
  selectedTab = "maintenance_po";
  activeTab = "Maintenance Vendor";
  errorMessage: string;
  erroralert = false;
  successalert = false;
  successMessage: string;
  SearchCity: any;
  public todayDate: any = new Date();
  searchString;
  from_date;
  to_date;

  constructor(
    private categoryService: CategoryService,
    private LoaderService: LoaderService
  ) {}

  ngOnInit() {
    this.getFilterData();
    this.SearchCity = "All";
  }

  activateTab(tab) {
    this.selectedTab = tab;
    switch (tab) {
      case "retail_po":
        this.activeTab = "Retail Vendor";
        break;
      case "maintenance_po":
        this.activeTab = "Maintenance Vendor";
        break;
    }
  }
  city_list = [];
  getFilterData() {
    this.categoryService.getCities().subscribe(
      (res) => {
        this.city_list = res["cities"];
      },
      (err) => {}
    );
  }
  final_from_date;
  final_to_date;
  city_id;
  ClearDateFilter() {
    this.to_date = "";
    this.from_date = "";
    this.final_from_date = "";
    this.final_to_date = "";
    this.searchString = "";
    this.city_id = "";
    this.SearchCity = "All";
  }
  vendorsList: any = [];
  searchFun() {}
  SubmitDate() {
    if (this.from_date !== undefined && this.from_date !== "") {
      var todayTime = this.from_date;
      var month = parseInt(("0" + (todayTime.getMonth() + 1)).slice(-2));
      var day = todayTime.getDate();
      var year = todayTime.getFullYear();
      this.final_from_date = day + "-" + month + "-" + year;
    }
    if (this.to_date !== undefined && this.to_date !== "") {
      var todayTime = this.to_date;
      var month = parseInt(("0" + (todayTime.getMonth() + 1)).slice(-2));
      var day = todayTime.getDate();
      var year = todayTime.getFullYear();
      this.final_to_date = day + "-" + month + "-" + year;
    }
  }
  cityFilter(e) {
    this.city_id = e;
    
  }
}



// WEBPACK FOOTER //
// ./src/app/platform/category/category/vendorpo-maintenance/vendorpo-maintenance.component.ts